import { Values } from "Tools/Values";

export default (value: string) => {
  let error;
  const str: string = String(value);
  if (str.length === 0) {
    error = Values.getLocalizationValue("fieldRequired");
  }
  return error;
};
